import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IChips, IChipsConfig } from '@shared/components/v1/chips/chips.interface';
import { STRING_CONSTANTS } from '@config/constants/string.constants';
import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MatRipple } from '@angular/material/core';

@Component({
  selector: 'app-chips',
  standalone: true,
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
  imports: [CommonModule, InlineSVGModule, MatRipple],
})
export class ChipsComponent implements OnInit, OnChanges {
  @Input() chipsList: IChips[] = [];
  @Input() selectedChipsList: IChips[] = [];
  @Input() config!: IChipsConfig;
  // Optional async gate sebelum chip beneran dihapus (mis. modal konfirmasi) — kalau di-set dan
  // resolve-nya false, batalkan penghapusan (state chip gak disentuh sama sekali).
  @Input() confirmRemove?: (chip: IChips) => Promise<boolean> | boolean;

  @Output() selectedChips = new EventEmitter<IChips[]>();

  showMore = false;

  defaultConfig = <IChipsConfig>{
    disabled: false,
    labelTextStyle: 'capitalize',
    showLimit: false,
    limit: 5,
    clickToSelect: false,
  };

  private chipsListDataSubject = new BehaviorSubject(this.chipsList);

  get ChipsListData() {
    return this.chipsListDataSubject.value;
  }

  set ChipsListData(val) {
    this.chipsListDataSubject.next(val);
  }

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedChipsList && changes.selectedChipsList.currentValue.length > 0) {
      this.selectedChipsList = changes.selectedChipsList.currentValue;
      this.chipsList.map((chips) => {
        this.selectedChipsList.forEach((val) => {
          if (chips.id === val.id) {
            chips.selected = val.selected;
            chips.disabled = val.disabled;
          }
        });
      });
    }
  }

  ngOnInit() {
    this.initChips();
    this.initChipsConfig();
  }

  initChipsConfig() {
    this.config = {
      ...this.config,
      disabled: this.config?.disabled ?? this.defaultConfig.disabled,
      labelTextStyle: this.config?.labelTextStyle ?? this.defaultConfig.labelTextStyle,
      showLimit: this.config?.showLimit ?? this.defaultConfig.showLimit,
      limit: this.config?.limit ?? this.defaultConfig.limit,
      clickToSelect: this.config?.clickToSelect ?? this.defaultConfig.clickToSelect,
    };
  }

  initChips() {
    if (this.hasParentInputChipsList()) return;
    this.chipsListDataSubject.subscribe((data) => {
      this.chipsList = this.handleMapSelectedChips(data);
      this.selectedChips.emit(this.chipsList);
    });
  }

  async handleRemoveChip(chips: IChips) {
    if (this.confirmRemove && !(await this.confirmRemove(chips))) return;

    this.chipsList.map((item) => (item.selected = item.id !== chips.id));
    this.chipsList = this.chipsList.filter((item) => item.id !== chips.id);

    // reset chips
    this.chipsListDataSubject.next(this.chipsList);
    this.selectedChips.emit(this.chipsList);
  }

  handleMapSelectedChips(data: IChips[]) {
    return [...new Map(data.map((item) => [item.id, item])).values()];
  }

  handleToggleSelectChips(chips: IChips) {
    if (!this.config?.clickToSelect) return;
    chips.selected = !chips.selected;
    this.selectedChips.emit(this.chipsList.filter((chip) => chip.selected));
    this.chipsListDataSubject.next([...this.chipsList]);
  }

  toggleShowMore = () => (this.showMore = !this.showMore);

  hasParentInputChipsList = () => !!this.chipsList.length;

  isShowToggleMore = () => {
    if (this.config && this.config?.showLimit) return (this.chipsList && this.chipsList.length) > (this.config?.limit ?? 0);
  };

  isSelectedChips = (chips: IChips) => this.selectedChipsList.some((selected) => selected.id === chips.id);

  getLengthNum = () => this.chipsList.length - (this.config?.limit ?? 0);

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
